import { Box } from "@mui/material";
import { useContext, useState } from "react";
import SwipeableViews from "react-swipeable-views";
import TopSellersContext from "../../context/TopSellersContext";
import TopSellersSection from "./TopSellersSection";

export default function TopSellers() {
  const { topSellersGroups, loading } = useContext(TopSellersContext);
  const [index, setIndex] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState(null);

  if (loading) return null;

  return (
    <Box sx={{ width: "100%", maxWidth: 1460, mx: "auto", p: { xs: 2, md: 3 } }}>
      <SwipeableViews
        index={index}
        onChangeIndex={setIndex}
        enableMouseEvents
        sx={{ width: "100%" }}
      >
        {topSellersGroups.map((group, i) => (
          <Box key={i}>
            <TopSellersSection
              title={group.name}
              categories={group.categories
                .split(",")
                .map((c) => c.trim())
                .filter(Boolean)}
              image={group.image}
              onSelectProduct={setSelectedProduct}
              selectedProduct={selectedProduct}
              onBack={() => setSelectedProduct(null)}
              showControls={topSellersGroups.length > 1 && !selectedProduct}
              onPrev={() => setIndex((prev) => Math.max(prev - 1, 0))}
              onNext={() =>
                setIndex((prev) =>
                  Math.min(prev + 1, topSellersGroups.length - 1),
                )
              }
              isFirst={index === 0}
              isLast={index === topSellersGroups.length - 1}
            />
          </Box>
        ))}
      </SwipeableViews>
    </Box>
  );
}
